// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3J42I","additionalInfo":"AgreementModal_additionalInfo__3MXe4"};